import React from 'react'
import SvgIcon from '@mui/material/SvgIcon'
import Typography from '@mui/material/Typography'
import ErrorFilled from '@tdcerhverv/parrotfish/icons/ErrorFilled'

type ErrorMessageProps = {
  children: React.ReactNode
}

const ErrorMessage = ({ children }: ErrorMessageProps) => (
  <Typography
    variant="body2"
    component="span"
    sx={{ display: 'flex', alignItems: 'center', gap: '8px', lineHeight: 1 }}
  >
    <SvgIcon fontSize="small" component={ErrorFilled} viewBox="0 0 48 48" />
    {children}
  </Typography>
)

export default ErrorMessage
